module.exports = __webpack_public_path__ + "img/not_found.e71f259e.png";